// tslint:disable: completed-docs
import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-sails/core';
import {
    NAMESPACE,
    MARKUP_ID,
    OPTION_PICKER_DESTINATION,
    OPTION_PICKER_TARIFF,
    DESTINATIONS,
    STEP_01,
    STEP_02,
    STEP_03,
    NOTIFICATION_CONTAINER,
    ROAMING_OPTIONS_CONTAINER,
    UI_STATE,
    RESULTS,
} from './constants';
import reducer from './reducer';
import {
    countriesSelector,
    selectAvailibleTariffs,
    selectCountries,
    selectError,
    selectLoading,
    selectRoamingOptions,
    selectUiState,
} from './selector';
import {
    Clearable,
    OptionVO,
    RaError,
    RoamingOption,
    RootState,
} from './types';
import { createStructuredSelector } from 'reselect';
import {
    setDefaultState,
    setDestination,
    setCountry,
    setTariff,
} from './action';
import { Country } from './types'; './types.d';
import raSaga from './saga';
import {
    show,
    hide,
    focusDiv,
} from './utils/utils';

import { mountSuggestField } from '../../components/SuggestField';
import { mountOptionPicker } from '../../components/OptionPicker';
import { mountRoamingOption } from '../../components/RoamingOption';
import { mountNotification } from '../../components/Notification';
import { mountLoadingSpinner } from '../../components/LoadingSpinner';
const i18nConfig = require('./locales/de.json');

const roamingAdvisorMarkup = require('./hbs/index.hbs');

function roamingAdvisor (state, action) {
    // reducer
    injectReducer(NAMESPACE, reducer);
    // saga
    injectSaga(NAMESPACE, raSaga);

    // root markup
    document.getElementById(MARKUP_ID).innerHTML = roamingAdvisorMarkup(i18nConfig);

    const step01 = document.getElementById(STEP_01);
    const step02 = document.getElementById(STEP_02);
    const step03 = document.getElementById(STEP_03);
    const results = document.getElementById(RESULTS);
    const resultsList = document.getElementById(ROAMING_OPTIONS_CONTAINER);
    const errorContainer = document.getElementById(NOTIFICATION_CONTAINER);

    // loading spinnter
    const loadingSpinner = mountLoadingSpinner();

    // destination option picker
    mountOptionPicker(OPTION_PICKER_DESTINATION, DESTINATIONS, e => {
        action.setDestination(e.target.value);
        suggestField.clear();
    }, 'optionPickerDestination');

    // tariff option picker

    let optionPickerTariffs: Clearable;

    // initialized later
    let suggestField: Clearable;

    action.setDefaultState();

    // getDerivedStateFromProps
    return {
        getDerivedStateFromProps ({ loading, countries, uiState, roamingOptions, error, availibleTariffs }, oldState) {
            loading ? loadingSpinner.show() : loadingSpinner.hide();

            if (countries && !oldState.countries) {
                suggestField = mountSuggestField(countriesSelector(countries), e => {
                    if (e) {
                        const selectedArrayItem = countries.find(element => element.name === e);
                        action.setCountry(selectedArrayItem.countryCode);
                    }
                    else {
                        action.setCountry();
                    }

                    optionPickerTariffs.clear();
                });
            }

            // Roaming Options
            if (roamingOptions) {
                // clear existing divs if any
                while (resultsList.firstChild) {
                    resultsList.removeChild(resultsList.firstChild);
                }

                // add the new romaing options
                roamingOptions.forEach(e => mountRoamingOption(ROAMING_OPTIONS_CONTAINER, e));
            }

            // Availble Tariffs

            if (!optionPickerTariffs || availibleTariffs.length !== oldState.availibleTariffs.length) {
                optionPickerTariffs = mountOptionPicker(OPTION_PICKER_TARIFF, availibleTariffs, e => {
                    action.setTariff(e.target.value, state.destination, state.countryCode);
                }, 'optionPickerTariffs') as Clearable;
            }

            // uiState

            switch (uiState) {
                case UI_STATE.SELECT_DESTINATION:
                    if (!error) {
                        hide(step02);
                        hide(step03);
                        hide(results);
                        //  suggestField.clear();
                    }
                    else {
                        hide(step01);
                        hide(step02);
                        hide(step03);
                        hide(results);
                    }

                    break;
                case UI_STATE.SELECT_COUNTRY:
                    show(step02);
                    hide(step03);
                    hide(results);
                    focusDiv(step01);
                    suggestField.clear();
                    optionPickerTariffs.clear();
                    break;
                case UI_STATE.SELECT_TARIFF:
                    show(step02);
                    show(step03);
                    hide(results);
                    focusDiv(step02);
                    optionPickerTariffs.clear();
                    break;

                case UI_STATE.TARIFF_SELECTED:
                    show(step02);
                    show(step03);
                    hide(results);
                    break;

                case UI_STATE.DISPLAY_OPTIONS:
                    show(step02);
                    show(step03);
                    focusDiv(results);
                    show(results);
                    break;

                case UI_STATE.NO_ROAMING_FOR_SELECTION:
                    show(step02);
                    hide(step03);
                    hide(results);
                    focusDiv(step01);
                    break;
            }

            // error handling
            if (error) {
                while (errorContainer.firstChild) {
                    errorContainer.removeChild(errorContainer.firstChild);
                }

                show(errorContainer);
                mountNotification(error);
            }
            else {
                hide(errorContainer);
            }
        },
    };
}

interface StateProps {

    loading: boolean;
    countries: boolean | Array<Country>;
    uiState: UI_STATE;
    roamingOptions: boolean | Array<RoamingOption>;
    error: boolean | RaError;
    availibleTariffs: boolean | Array<OptionVO>;
}

/** State Mapping */
const mapStateToProps = createStructuredSelector<RootState, StateProps>({
    loading: selectLoading(),
    countries: selectCountries(),
    uiState: selectUiState(),
    roamingOptions: selectRoamingOptions(),
    error: selectError(),
    availibleTariffs: selectAvailibleTariffs(),

});
const mapDispatchToProps = {
    setDefaultState,
    setDestination,
    setCountry,
    setTariff,

};

export default connect(mapStateToProps, mapDispatchToProps)(roamingAdvisor);
